import { getContainer } from '@framework/di/getContainer';
import { I18nInstance } from '../constants';
import { I18nInstanceType } from '../types';

const useI18nInstance = () => {
  const container = getContainer();

  return container.get<I18nInstanceType>(I18nInstance);
};

export default useI18nInstance;
